import React from "react";

// Decorative globe / trajectory SVG. Pure SVG, gold strokes, low opacity.
const GlobeLines = ({ className = "" }) => (
    <svg
        viewBox="0 0 800 800"
        xmlns="http://www.w3.org/2000/svg"
        className={`globe-bg ${className}`}
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
    >
        <defs>
            <radialGradient id="fade" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#C9A14A" stopOpacity="0.6" />
                <stop offset="100%" stopColor="#C9A14A" stopOpacity="0" />
            </radialGradient>
        </defs>

        {/* Outer circle */}
        <circle cx="400" cy="400" r="300" fill="none" stroke="#C9A14A" strokeWidth="0.6" opacity="0.5" />
        <circle cx="400" cy="400" r="240" fill="none" stroke="#C9A14A" strokeWidth="0.4" opacity="0.3" />
        <circle cx="400" cy="400" r="180" fill="none" stroke="#C9A14A" strokeWidth="0.4" opacity="0.25" />
        <circle cx="400" cy="400" r="120" fill="none" stroke="#C9A14A" strokeWidth="0.4" opacity="0.2" />

        {/* Longitudes (ellipses) */}
        {[0, 30, 60, 90, 120, 150].map((deg) => (
            <ellipse
                key={deg}
                cx="400"
                cy="400"
                rx="300"
                ry="90"
                fill="none"
                stroke="#C9A14A"
                strokeWidth="0.5"
                opacity="0.3"
                transform={`rotate(${deg} 400 400)`}
            />
        ))}

        {/* Latitudes */}
        {[100, 180, 260, 340, 420, 500, 580, 660, 740].map((cy, i) => {
            const dy = cy - 400;
            const rx = Math.sqrt(Math.max(0, 300 * 300 - dy * dy));
            return (
                <ellipse
                    key={i}
                    cx="400"
                    cy={cy}
                    rx={rx}
                    ry="6"
                    fill="none"
                    stroke="#C9A14A"
                    strokeWidth="0.4"
                    opacity="0.18"
                />
            );
        })}

        {/* Trajectory arcs */}
        <path d="M 120 450 Q 400 80 680 450" stroke="#C9A14A" strokeWidth="0.8" fill="none" opacity="0.45" strokeDasharray="3 4" />
        <path d="M 80 520 Q 400 200 720 380" stroke="#C9A14A" strokeWidth="0.6" fill="none" opacity="0.3" strokeDasharray="2 5" />

        {/* Hub dots */}
        {[
            [220, 380], [440, 300], [550, 430], [300, 500], [620, 360]
        ].map(([cx, cy], i) => (
            <g key={i}>
                <circle cx={cx} cy={cy} r="3" fill="#C9A14A" opacity="0.8" />
                <circle cx={cx} cy={cy} r="8" fill="none" stroke="#C9A14A" strokeWidth="0.4" opacity="0.4" />
            </g>
        ))}
    </svg>
);

export default GlobeLines;
